export const moveItemToFront =
  <T>(condition: (x: T) => boolean): ((x: T, y: T) => -1 | 0 | 1) =>
  (x: T, y: T) => {
    if (condition(x)) {
      return -1;
    }
    return condition(y) ? 1 : 0;
  };
